export class Navigation{
  public aktuelle_seite: string = undefined
  public vorhergehende_seite: string = undefined

  public set(seite){
    this.vorhergehende_seite = this.aktuelle_seite
    this.aktuelle_seite = seite
  }
}